import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_ACTIVE_PROCESS,
  CLEAR_ACTIVE_PROCESSES,
  CLEAR_PROCESS,
  CLEAR_PROCESSES,
  FLAG_ACTIVE_PROCESS_ACTIVITY,
  FLAG_GETTING_ACTIVE_PROCESSES,
  FLAG_GETTING_PROCESSES,
  FLAG_PROCESS_ACTIVITY,
  GET_ACTIVE_PROCESS,
  GET_ACTIVE_PROCESSES,
  GET_PROCESS,
  GET_PROCESSES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  active: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  selectedActive: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_PROCESSES:
      return state.setIn(['all', 'loading'], payload);
    case GET_PROCESSES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PROCESSES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_PROCESS_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_PROCESS:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_PROCESS:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_GETTING_ACTIVE_PROCESSES:
      return state.setIn(['active', 'loading'], payload);
    case GET_ACTIVE_PROCESSES:
      return state.setIn(['active', 'content'], Immutable.List(payload));
    case CLEAR_ACTIVE_PROCESSES:
      return state.setIn(
        ['active', 'content'],
        INITIAL_STATE.getIn(['active', 'content']),
      );
    case FLAG_ACTIVE_PROCESS_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['selectedActive', 'activity'],
          state.getIn(['selectedActive', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['selectedActive', 'activity'],
        state.getIn(['selectedActive', 'activity']).pop(),
      );
    case GET_ACTIVE_PROCESS:
      return state.setIn(['selectedActive', 'content'], Immutable.Map(payload));
    case CLEAR_ACTIVE_PROCESS:
      return state.setIn(
        ['selectedActive'],
        INITIAL_STATE.getIn(['selectedActive']),
      );
    default:
      return state;
  }
};
